export const BERNOULLI_ADP_KEY = 'wlc360ai-w3f-bernoulli';

export type BernoulliAdpConfig = {
  name: string;
  id: string;
  id_provider: 'appkey';
  key: string;
  line_name: string;
  env: 'dev' | 'stg' | 'prd';
  region: 'us';
};

// Fallback line_name used when Bernoulli runs standalone (not embedded in a host shell).
// When embedded, the host shell's site-config adp.line_name takes precedence via RuntimeAdpConfig.
export const BERNOULLI_ADP_BY_ENV: Record<
  'dev' | 'stg' | 'prd',
  BernoulliAdpConfig
> = {
  dev: {
    name: 'W3F Bernoulli',
    id: 'UPGH1gDIvrt2I2oxmOa3PT5UUXfK7064NAonfEfQGcW8iZFG',
    id_provider: 'appkey',
    key: BERNOULLI_ADP_KEY,
    line_name: 'WLC360A',
    env: 'dev',
    region: 'us',
  },
  stg: {
    name: 'W3F Bernoulli',
    id: 'UPGH1gDIvrt2I2oxmOa3PT5UUXfK7064NAonfEfQGcW8iZFG',
    id_provider: 'appkey',
    key: BERNOULLI_ADP_KEY,
    line_name: 'WLC360A',
    env: 'stg',
    region: 'us',
  },
  prd: {
    name: 'W3F Bernoulli',
    id: 'VxnTgD5GzEGBLFGaqveSYWVRicouMoAQ89adTjlO0GtH36gM',
    id_provider: 'appkey',
    key: BERNOULLI_ADP_KEY,
    line_name: 'WLC360A',
    env: 'prd',
    region: 'us',
  },
};
